const escaparHtml = valor =>
  String(valor != null ? valor : '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

const gerarTabelaErros = erros => {
  const singular = erros.length === 1;
  const titulo = singular ? 'Boleto não gerado' : 'Boletos não gerados';
  const descricao = singular
    ? 'Confira abaixo o título que não pôde ser processado.'
    : 'Confira abaixo os títulos que não puderam ser processados.';

  return `
  <style>@media print { .relatorio-erros-boletos { display: none !important; } }</style>
  <section class="relatorio-erros-boletos" style="box-sizing: border-box; font-family: Arial, Helvetica, sans-serif; margin: 24px auto 32px; max-width: 1100px; padding: 0 20px; color: #263238;">
    <div style="background: #fff8f7; border: 1px solid #ffc9c2; border-left: 5px solid #d32f2f; border-radius: 10px; box-shadow: 0 3px 12px rgba(38, 50, 56, .10); overflow: hidden;">
      <div style="align-items: center; background: linear-gradient(135deg, #fff3f1 0%, #ffffff 100%); display: flex; gap: 12px; padding: 18px 22px;">
        <span style="align-items: center; background: #d32f2f; border-radius: 50%; color: #fff; display: inline-flex; font-size: 18px; font-weight: bold; height: 30px; justify-content: center; width: 30px;">!</span>
        <div>
          <h2 style="color: #b71c1c; font-size: 19px; margin: 0 0 4px;">${titulo}</h2>
          <p style="color: #6d4c41; font-size: 13px; margin: 0;">${descricao}</p>
        </div>
      </div>
      <div style="overflow-x: auto; padding: 0 22px 22px;">
        <table cellpadding="0" cellspacing="0" style="border-collapse: separate; border-spacing: 0; font-size: 14px; min-width: 680px; overflow: hidden; width: 100%;">
          <thead><tr style="background: #37474f; color: #fff; text-align: left;"><th style="padding: 13px 14px;">Sacado</th><th style="padding: 13px 14px;">Valor</th><th style="padding: 13px 14px;">Vencimento</th><th style="padding: 13px 14px;">Motivo</th></tr></thead>
          <tbody>${erros
            .map(
              erro =>
                `<tr style="background: #fff; border-bottom: 1px solid #eceff1;"><td style="border-bottom: 1px solid #eceff1; padding: 13px 14px;">${escaparHtml(
                  erro.sacado
                )}</td><td style="border-bottom: 1px solid #eceff1; padding: 13px 14px; white-space: nowrap;">${escaparHtml(
                  erro.valor
                )}</td><td style="border-bottom: 1px solid #eceff1; padding: 13px 14px; white-space: nowrap;">${escaparHtml(
                  erro.vencimento
                )}</td><td style="border-bottom: 1px solid #eceff1; padding: 13px 14px;"><span style="background: #ffebee; border-radius: 999px; color: #b71c1c; display: inline-block; font-size: 12px; font-weight: 600; padding: 5px 10px;">${escaparHtml(
                  erro.erro
                )}</span></td></tr>`
            )
            .join('')}</tbody>
        </table>
      </div>
    </div>
  </section>
`;
};

export default gerarTabelaErros;
